<template>
  <div class="cdi-option">
    <b-field
      label="Informe com detalhes qual a finalidade e onde necessita apresentar o atestado"
    >
      <b-input type="textarea" v-model="textInput" />
    </b-field>
    <div class="block">
      <h2 class="label">
        Atendendo as orientações da Resolução CFM n. 1658/2002 do Conselho
        Federal de Medicina, escolha a opção de sua preferência
      </h2>
      <b-field>
        <b-radio
          name="name"
          @input="$emit('input-radio')"
          native-value="false"
          v-model="radioChecked"
        >
          Não - Não autorizo a inclusão do meu diagnóstico (CID) no documento
          solicitado
        </b-radio>
      </b-field>
      <b-field>
        <b-radio
          name="name"
          @input="$emit('input-radio')"
          native-value="true"
          v-model="radioChecked"
        >
          Sim - Autorizo a inclusão do meu diagnóstico (CID) no documento
          solicitado
        </b-radio>
      </b-field>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'CdiOption',
  data() {
    return {
      radioChecked: ''
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    textInput: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    },
    toBoolean() {
      let realBolean = true
      this.radioChecked === 'true' ? (realBolean = true) : (realBolean = false)
      return realBolean
    }
  },
  updated() {
    this.handleData()
  },
  methods: {
    ...mapMutations(['SET_ATESTADO_DADOS', 'DESABILITAR_BOTAO_ENVIAR']),
    handleData() {
      this.DESABILITAR_BOTAO_ENVIAR(!(this.radioChecked && this.value))
      this.SET_ATESTADO_DADOS(this.toBoolean)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';
.cdi-option {
  margin-top: 2rem;
  .textarea {
    resize: none;
  }
  .block {
    margin-top: 2rem;
    max-width: 80%;
    padding-bottom: 2.5rem;
  }
  .label {
    margin-bottom: 0.9rem;
  }
}
@media (max-width: $mobile-width-breakpoint) {
  .cdi-option {
    .block {
      max-width: 100%;
    }
    .warning {
      max-width: 100%;
    }
  }
}
</style>
